<div class="end-page">
  Made with ❤️ by
  <a href="https://www.linkedin.com/in/chance-lau-oops/">Chance</a>,
  <a href="https://www.linkedin.com/in/dylon-tjanaka-971508192/">Dylon</a>, and
  <a href="https://www.linkedin.com/in/shaunna-caffrey-927516178/">Shaunna</a>
</div>
